import styled from 'styled-components/macro';

import {useState} from "react";
import {
    Button,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";
import {useModal} from "../store";
import {useSignIn} from "../api/sign_in";
import useToggle from "../utils/use_toggle";
import {useFeedback} from "../store/feedback";
// eslint-disable-next-line import/no-cycle
import Signup from "./signup";
import NavLink from "./nav_link";

const Login = styled(({className, onClose}) => {
    const modal = useModal();
    const [login, setLogin] = useState({
        username: '',
        password: '',
    });
    const set = (name) => (value) => setLogin((login) => ({...login, [name]: value}));
    const [passwordVisibility, togglePasswordVisibility] = useToggle(false);
    const handleRegister = () => {
        modal.open(Signup);
    };
    const {feedbackCh, error} = useFeedback();
    const signIn = useSignIn(feedbackCh);
    const [processing, setProcessing] = useState(false);
    const handleLogin = async () => {
        setProcessing(true);
        try {
            await signIn(login.username, login.password);
            onClose();
            history.replace('/');
        } catch {
            // error will be displayed
        }
        setProcessing(false);
    }
    const handleKeyPress = async (event) => {
        if (event.key === 'Enter'){
            await handleLogin();
        }
    }
    return (
            <Modal
                isOpen
                onClose={onClose}
            >
                <ModalOverlay />
                <ModalContent>
                        <ModalHeader>Log in</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={6}>
                                <input hidden />
                                <FormControl>
                                    <FormLabel>Username</FormLabel>
                                    <Input placeholder="" value={login.username} onKeyDown={handleKeyPress}
                                           onChange={(e) => set('username')(e.currentTarget.value)}/>
                                </FormControl>

                                <FormControl mt={4}>
                                    <FormLabel>Password</FormLabel>
                                    <Input placeholder="********" type='password' value={login.password} onKeyDown={handleKeyPress}
                                           onChange={(e) => set('password')(e.currentTarget.value)}/>
                                    <FormHelperText><NavLink href={'/reset'}>Forgot your password?</NavLink></FormHelperText>
                                </FormControl>

                                <FormControl isInvalid={error}>
                                    <FormErrorMessage>{error?.toString()}</FormErrorMessage>
                                </FormControl>

                        </ModalBody>

                        <ModalFooter>
                            <Button variant="cancel" mr={3} onClick={handleRegister}>Sign Up</Button>
                            <Button type='submit' variant="blue" isLoading={processing} onClick={handleLogin}>
                                Login
                            </Button>
                        </ModalFooter>
                </ModalContent>
            </Modal>
    )})`
`;

export default Login;
